import { useStore } from 'vuex';
/**
 * Composable for actions
 * Usage in Composition API:
 * 
 * import { useActions } from '@/composables/actions';
 * 
 * export default {
 *   setup() {
 *     const { addToQuoteBulk, clearCartApi, clearCartApiByTimer, clearCartByProgram, deletePP, deleteProduct, doLogout, fetchCart, fetchCartAndMeta, fetchCartMeta, fetchColorBubbles, fetchQuoteList, fetchWishList, logout } = useActions();
 *     return { addToQuoteBulk, clearCartApi, clearCartApiByTimer, clearCartByProgram, deletePP, deleteProduct, doLogout, fetchCart, fetchCartAndMeta, fetchCartMeta, fetchColorBubbles, fetchQuoteList, fetchWishList, logout };
 *   }
 * }
 */
export function useActions() {
    const store = useStore();

    const addToQuoteBulk = () => {
        store.dispatch('addToQuoteBulk');
    }
    const clearCartApi = () => {
        store.dispatch('clearCartApi');
    }
    const clearCartApiByTimer = () => {
        return store.dispatch('clearCartApiByTimer');
    }
    const clearCartByProgram = () => {
        return store.dispatch('clearCartByProgram');
    }
    const deletePP = () => {
        store.dispatch('deletePP');
    }
    const deleteProduct = () => {
        store.dispatch('deleteProduct');
    }
    const doLogout = () => {
        store.dispatch('doLogout');
    }
    const fetchCart = () => {
        store.dispatch('fetchCart');
    }
    const fetchCartAndMeta = () => {
        return store.dispatch('fetchCartAndMeta');
    }
    const fetchCartMeta = () => {
        return store.dispatch('fetchCartMeta');
    }
    const fetchColorBubbles = () => {
        store.dispatch('fetchColorBubbles');
    }
    const fetchQuoteList = () => {
        store.dispatch('fetchQuoteList');
    }
    const fetchWishList = () => {
        store.dispatch('fetchWishList');
    }
    const logout = () => {
        store.dispatch('logout');
    }
    return { 
        addToQuoteBulk,
        clearCartApi,
        clearCartApiByTimer,
        clearCartByProgram,
        deletePP,
        deleteProduct,
        doLogout,
        fetchCart,
        fetchCartAndMeta,
        fetchCartMeta,
        fetchColorBubbles,
        fetchQuoteList,
        fetchWishList,
        logout
    };
}